import { getCachedData, setCachedData } from "api/Cache";
import { fetchProjectEntities } from "api/Entities";

export const getProjectEntities = async (projectId: string, done: (entities: any) => void) => {
    var cachedData = getCachedData();
    if (cachedData["entities"][projectId]) {
        done(cachedData["entities"][projectId]);
    } else {
        var entities = await fetchProjectEntities(projectId);
        done(entities);
    }
};

export const updateData = (
    action: string,
    type: string,
    projectId: string,
    updatedObject: any,
    done?: (object?: any) => void
) => {
    // console.log("action:", action, "|type:", type, "|projectId:", projectId, "|updatedObject:", updatedObject);
    var cachedData = getCachedData();
    const cachedObject = cachedData[type][projectId];
    const pending = cachedData["pending"];
    const pendingArray = Object.values(pending);
    switch (type) {
        case "entities": {
            switch (action) {
                case "create": {
                    if (cachedObject) {
                        cachedData[type][projectId][updatedObject.ID] = updatedObject;
                        if (
                            !pendingArray.find(
                                (element: any) =>
                                    element.view_type === "folder" &&
                                    element.ID === updatedObject.ID &&
                                    element.name === updatedObject.name
                            )
                        ) {
                            const newEntry = { ...updatedObject };
                            pending[newEntry.ID] = newEntry;
                            cachedData["pending"] = pending;
                            setCachedData(cachedData);
                        }
                    }
                    break;
                }
                case "update": {
                    if (cachedObject) {
                        cachedData = {
                            ...cachedData,
                            [type]: {
                                ...cachedData[type],
                                [projectId]: {
                                    ...cachedData[type][projectId],
                                    [updatedObject.ID]:  updatedObject
                                }
                            }
                        }
                        console.log("cachedData:", cachedData);
                        setCachedData(cachedData);
                    }
                    break;
                }
                case "updateEntity": {
                    if (cachedData[type][projectId][updatedObject.ID]) {
                        cachedData[type][projectId][updatedObject.ID] = updatedObject;
                        //StorageUtils.saveToLocalStorage('data', { ...cachedData[type] });
                        pending[updatedObject.ID] = updatedObject;
                        cachedData["pending"] = pending;
                        setCachedData(cachedData);
                    }
                    break;
                }
                case "save": {
                    cachedData[type][projectId][updatedObject.ID] = updatedObject;
                    setCachedData(cachedData);
                    break;
                }
                case "delete": {
                    var entries = cachedData[type][projectId];
                    if (updatedObject && entries[updatedObject.ID]) {
                        delete entries[updatedObject.ID];
                    }
                    cachedData[type][projectId] = entries;
                    const newEntry = { ...updatedObject, action: "remove" };
                    pending[newEntry.ID] = newEntry;
                    cachedData["pending"] = pending;
                    setCachedData(cachedData);
                    break;
                }
            }
            break;
        }
        case "views": {
            switch (action) {
                case "create": {
                    if (!cachedObject) {
                        cachedData[type][projectId] = updatedObject;
                        const newEntry = { ...updatedObject, action: "add" };
                        pending[newEntry.ID] = newEntry;
                        cachedData["pending"] = pending;
                        setCachedData(cachedData);
                    }
                    break;
                }
                case "updateIcon": {
                    if (cachedObject) {
                        cachedObject.thumb = updatedObject;
                    }
                    break;
                }
                case "update": {
                    if (cachedData[type][projectId]) {
                        cachedData[type][projectId] = updatedObject;
                        setCachedData(cachedData);
                    }
                    break;
                }
                case "save": {
                    cachedData[type][projectId] = updatedObject;
                    cachedData["pending"] = [];
                    setCachedData(cachedData);
                    break;
                }
                case "delete": {
                    var views = cachedData["views"];
                    delete views[projectId];
                    cachedData["views"] = { ...views };
                    setCachedData(cachedData);

                    const pendingIndex = pendingArray.findIndex((entry: any) => entry.ID === projectId);
                    if (pendingIndex !== -1) {
                        pendingArray.splice(pendingIndex, 1);
                        cachedData["pending"] = [...new Set(pendingArray)];
                        setCachedData(cachedData);
                    }
                    if (done) {
                        done();
                    }
                    break;
                }
            }
            break;
        }
        case "projects": {
            switch (action) {
                case "create": {
                    cachedData[type][projectId] = updatedObject;
                    getProjectEntities(projectId, (entities) => {
                        cachedData["entities"][projectId] = entities;
                        setCachedData(cachedData);
                        if (done) {
                            done(projectId);
                        }
                    });
                    break;
                }
                case "update": {
                    if (cachedData[type][projectId]) {
                        cachedData[type][projectId] = updatedObject;
                        setCachedData(cachedData);
                    }
                    break;
                }
                case "delete": {
                    var projects = cachedData["projects"];
                    delete projects[projectId];
                    cachedData["projects"] = { ...projects };
                    setCachedData(cachedData);

                    var entities = cachedData["entities"];
                    delete entities[projectId];
                    cachedData["entities"] = { ...entities };
                    setCachedData(cachedData);
                    if (done) {
                        done();
                    }
                    break;
                }
            }
            break;
        }
        case "pending":
            {
                const view: any = pendingArray.find((entry: any) => entry.ID === projectId);
                if (view) {
                    const newEntry = { ...updatedObject };
                    const updatedView = { ...view, meta: newEntry };
                    cachedData["pending"] = [updatedView];
                    setCachedData(cachedData);
                }
            }
            break;
        case "snapshots": {
            switch (action) {
                case "add": {
                    if (!cachedObject) {
                        cachedData[type][projectId] = [updatedObject];
                        cachedData["snapshots"] = cachedData[type];
                        setCachedData(cachedData);
                    } else {
                        let snapshots: any = Object.values(cachedObject);
                        const newEntry = { ...updatedObject };
                        snapshots.push(newEntry);
                        cachedData["snapshots"][projectId] = snapshots;
                        setCachedData(cachedData);
                    }
                    break;
                }
                case "save": {
                    //saving snapshots
                    setCachedData(cachedData);
                    break;
                }
            }
            break;
        }
        case "comments": {
            switch (action) {
                case "save": {
                    cachedData[type][projectId] = updatedObject;
                    setCachedData(cachedData);
                    break;
                }
            }
            break;
        }
    }
    //console.log("action:", action, "cachedData:", cachedData);
};
